/** @typedef {string} ExternalQuestionnaireAttachStatus */
export const EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS_ALL = 'ALL';
export const EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS_ATTACHED = 'ATTACHED';
export const EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS_UNATTACHED = 'UNATTACHED';
/** @enum {ExternalQuestionnaireAttachStatus} */
export const EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS = {
	ALL: EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS_ALL,
	ATTACHED: EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS_ATTACHED,
	UNATTACHED: EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS_UNATTACHED,
};
/** @type {ExternalQuestionnaireAttachStatus[]} */
export const EXTERNAL_QUESTIONNAIRE_ATTACH_STATUSES = Object.values(EXTERNAL_QUESTIONNAIRE_ATTACH_STATUS);